import { useEffect, useRef, useMemo } from 'react'
import { DiscountModalProps } from './types'
import type { ShopifySectionComponent } from '@/types/ShopifySectionComponent'
import { SignupModal } from '../SignupModal'
import { useDiscountModalStore } from './store'

export const DiscountModal: ShopifySectionComponent<DiscountModalProps> = ({
  data,
}) => {
  const modalData = data!

  const {
    isOpen,
    autoPopupDismissed,
    hasSignedUp,
    open,
    close,
    dismissAutoPopup,
    checkSignupStatus,
  } = useDiscountModalStore()

  const wasOpenedByAutoPopup = useRef(false)

  const autoPopupEnabled = modalData.auto_popup_enabled ?? false
  const autoPopupDelay = modalData.auto_popup_delay ?? 5

  useEffect(() => {
    if (!autoPopupEnabled || hasSignedUp || autoPopupDismissed) {
      return
    }

    // homepage page only for the popup
    const isHomepage = window.location.pathname === '/'
    if (!isHomepage) {
      return
    }

    const timeoutId = setTimeout(() => {
      const store = useDiscountModalStore.getState()
      if (!store.hasSignedUp && !store.autoPopupDismissed && !store.isOpen) {
        wasOpenedByAutoPopup.current = true
        open()
      }
    }, autoPopupDelay * 1000)

    return () => clearTimeout(timeoutId)
  }, [autoPopupEnabled, autoPopupDelay, hasSignedUp, autoPopupDismissed, open])

  const handleOpenChange = (isNowOpen: boolean) => {
    if (!isNowOpen) {
      if (wasOpenedByAutoPopup.current) {
        dismissAutoPopup()
        wasOpenedByAutoPopup.current = false
      }

      close()
      checkSignupStatus()
    }
  }

  const signupModalData = useMemo(
    () => ({
      ...modalData,
      image: {
        src: modalData.image?.src,
      },
    }),
    [modalData],
  )

  return (
    <>
      <SignupModal
        data={signupModalData}
        open={isOpen}
        exclusive
        onOpenChange={handleOpenChange}
      />
    </>
  )
}
